import React, {useEffect} from "react";
import { Avatar, Space, Dropdown, Menu } from "antd";
import { useAuth0 } from '@auth0/auth0-react';
import {
  UserOutlined,
  SettingOutlined,
  PoweroffOutlined,
} from "@ant-design/icons";
import "./index.css";

const HeaderAvatar: React.FC = () => {
  const { user, logout, getAccessTokenSilently, getIdTokenClaims } = useAuth0();
  const { name, picture, email } = user || {name: '', picture: 'https://joeschmoe.io/api/v1/random', email: ''};

  const setToken = async () => {
    const token = await getAccessTokenSilently();
    localStorage.setItem('accessToken', token);
    const claims = await getIdTokenClaims();
    const id_token = claims?.__raw || '';
    localStorage.setItem('idToken', id_token);
    if(localStorage.getItem('apiStatusCode')==='401' || localStorage.getItem('apiStatusCode')==='403'){
      // localStorage.removeItem("apiStatusCode");
      // logout({ returnTo: window.location.origin });
    }

  }
    
  useEffect(() => {
    setToken();
  }, []);

  const menu = (
    <Menu
      className="avtMenuwidth"
      items={[
        {
          key: "1",
          icon: <Avatar src={picture} size={40} />,
          label: (
            <a rel="noopener noreferrer">
               {name} <br />
              <small className="lowerCase">{email}</small> 
            </a>
          ),
        },
        {
          key: "2",
          icon: <UserOutlined />,
          label: <a>My Profile</a>,
        },
        {
          key: "3",
          icon: <SettingOutlined />,
          disabled: true,
          label: <a>Setting</a>,
        },
        {
          key: "4",
          danger: true,
          icon: <PoweroffOutlined />,
          label: <a onClick={(e) => logout({ returnTo: window.location.origin })}>Logout</a>,
        },
      ]}
    />
  );

  return (
    <Space wrap>
      <Dropdown overlay={menu} placement="bottomRight" trigger={["click"]}>
        <a onClick={(e) => e.preventDefault()}>
          <Space>
            <Avatar
              src={picture}
              size={35}
              style={{ border: "2px solid #ffff", margin: "2rem 0rem" }}
            />
          </Space>
        </a>
      </Dropdown>
    </Space>
  );
};

export default HeaderAvatar;
